import { useEffect, useState } from 'react';

import config from '@/config';
// import useStateHandler from '@/hooks/useStateHandler';
import useQuery from '@/hooks/useQuery';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import ArtistVerifiedIcon from '@/shared-components/icons/components/user-profile/ArtistVerifiedIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import InspiringNavigation from '../components/InspiringNavigation';

import SearchFollowing from './search-following';
import SearchInspiring from './search-inspiring';

import './index.css';

function DisplayNameUsername({ fetchData }) {
  if(fetchData.user_type === "gallery" || fetchData.user_type === "artist") {
    return (
      <>
        <Text className="search-inspiring__user_name dots-on-overflow" medium paragraph>
          {fetchData.user_name}
          {fetchData.user_type === "artist" && fetchData.user_flags.suarteroad_completed ? <ArtistVerifiedIcon className="search-inspiring__artist-verified-icon"/> : <></>}
        </Text>

        <Text className="search-inspiring__user_username-small dots-on-overflow" small paragraph>
                    @{fetchData.user_username}
        </Text>
      </>
    );
  } else {
    return (
      <Text className="search-inspiring__user_username dots-on-overflow" medium paragraph>
        {fetchData.user_username}
      </Text>
    );
  }
}

export default function Inspiring({ open, close, fetchData, numberOfInspiring }) {
  const [currentPage, setCurrentPage] = useState('inspiring');
  const [followingCount, setFollowingCount] = useState(0);
  const { queryData } = useQuery(`${fetchData._id}_following`, `${config.apis.api.url}/user/followees/${fetchData._id}`, { username: "" }, {
    injectToken: true,
    invalidateWhen: [`FOLLOW_ACTION_ON_${fetchData._id}`]
  });

  useEffect(() => {
    if (queryData) {
      setFollowingCount(queryData?.data?.totalDocs || 0);
    }
  }, [queryData]);

  return (
    <>
      <GenericPopup open={open} className="search-inspiring__popup remove-scrollbar" opacity>
        <XIcon className="search-inspiring__popup-close-icon-x" onClick={close}/>
        <BackArrowIcon className="search-inspiring__popup-close-icon-back" onClick={close}/>
        <DisplayNameUsername fetchData={fetchData}/>
        
        <InspiringNavigation userProfileId={fetchData?.id} currentPage={currentPage} setCurrentPage={setCurrentPage} inspiringCount={numberOfInspiring} followingCount = {followingCount} fetchData = {fetchData}/>

        <div className="inspiring_following_popup-search-bar-content">
          {currentPage === 'inspiring' ? <SearchInspiring userId={fetchData._id}/> : <SearchFollowing userId={fetchData._id} currentPage={currentPage} setFollowingCount={setFollowingCount}/>}
        </div>

      </GenericPopup>
    </>
  );
}
